import { StratifyDocument } from "@stratify/shared";
import React from "react";
import { GenericAgentChatTab } from "./GenericAgentChatTab";
import { AgentContext } from "../types/agentConfig";

interface AgentChatTabProps {
  document: StratifyDocument;
}

export const AgentChatTab: React.FC<AgentChatTabProps> = ({ document }) => {
  // Create document agent context
  const context: AgentContext = {
    contextId: document.id,
    agentType: 'document',
    contextData: document,
  };

  // Use generic chat tab component
  return <GenericAgentChatTab context={context} />;
};